import { render, staticRenderFns } from "./staffRoster.vue?vue&type=template&id=60d5948f&scoped=true&"
import script from "./staffRoster.vue?vue&type=script&lang=js&"
export * from "./staffRoster.vue?vue&type=script&lang=js&"
import style0 from "./staffRoster.vue?vue&type=style&index=0&id=60d5948f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5948f",
  null
  
)

export default component.exports